// Aspect Ratio Calculator Tool — reduce a size to its ratio and resize.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const aspectRatioTool: Tool = {
  id: "aspect-ratio",
  name: () => m.ar_tool_name(),
  description: () => m.ar_tool_description(),
  icon: "📐",
  basePath: "/aspect-ratio",
  status: "stable",
  tags: ["aspect", "ratio", "resize", "design"],
  pages: [
    {
      name: () => m.ar_nav_main(),
      path: "/aspect-ratio",
      description: () => m.ar_nav_main_desc(),
      icon: "📐",
    },
  ],
};
